import React from 'react'
import deniewImg from "../../assets/images/404-error.avif"
import { Link } from 'react-router-dom'
import { app_url } from 'app_config'

const NotFound = () => {

    return (
        <>
            <div className='text-center py-5 bg-white rounded' style={{ minHeight: '100vh' }}>
                <div>
                    <img src={deniewImg} alt="" height={350} />
                </div>
                <div>
                    <Link to={`${app_url}`} className="btn btn-primary px-5 py-3 fs-5 bg-blue ">
                        Go to Dashboard
                    </Link>
                </div>
            </div>
        </>
    )
}

export default NotFound